<template>
  <div class="footer footer-main">
    <div class="footer-logo">
      <a :href="footerLogoLink">
        <img class="footer-logo-procon" src="@/assets/proconlogo-h21.svg" alt="Footer Logo">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer-component",
  data() {
    return {
      footerLogoLink: "#"
    };
  }
};
</script>
<style scoped lang="scss">
.footer-logo {
  .footer-logo-procon {
    width: 145px;
    height: 30px;
  }
}
</style>
